import React, { useCallback, useEffect, useState } from "react";
import { H1, H3 } from "../../../../components/UI/generalLayout/Layout.styled";
import Styled from "./ListProblem.styled";
import { SolidButton } from "../attendanceRecord/AttendanceRecord.styled";
import useResponsiveInfo from "../../../../hooks/useResponsiveInfo";
import Colors from "../../../../constants/Colors";
import { useLocation, useNavigate } from "react-router-dom";
import { Paths } from "../../../../enums/Paths";
import { useSelector } from "react-redux";
import { SchedulingService } from "../../../../core/http/service/SchedulingService";
import { AppointmentStatus } from "../../../../enums/AppointmentStatus";
import * as attendanceRecordActions from "../../../../store/actions/attendanceRecord";
import { useAppDispatch } from "../../../..";
import { AppointmentService } from "../../../../core/http/service/AppointmentService";
import { isNull } from "lodash";
import { CircularProgress } from "@mui/material";
import * as appointmentActions from "../../../../store/actions/appointment";

interface IListProblem {
  pessoa: any;
  agendamento: any;
}

const ListProblem = ({ pessoa, agendamento }: IListProblem) => {
  const { isMobile } = useResponsiveInfo();
  const [problems, setProblems] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(true);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const attendance = useSelector((state: any) => state.attendance);
  const { state } = useLocation();

  const service: AppointmentService = new AppointmentService();

  const { currentProfile }: any = useSelector((state: any) => state.login);
  const acessoProntuario = useSelector((state: any)=> state.person.acessoProntuario)
  
  const fetchAtendimentos = useCallback(async () => {
    const pId = pessoa?.idPessoa ?? pessoa?.id;
    if (!pId) return;
    const appointment = await dispatch(
      appointmentActions.fetchAppointmentOpenByPacienteId(pId)
    );

    setHasAgendamentoEmAberto(appointment?.length > 0);
  }, [pessoa?.idPessoa, pessoa?.id, dispatch]);

  const [isAgendamentoRealizado, setIsAgendamentoRealizado] =
    useState<boolean>(true);

  const [hideAtendimentoButton, setHidenAtendimentoButton] =
    useState<boolean>(false);
  const [hasAgendamentoEmAberto, setHasAgendamentoEmAberto] =
    useState<boolean>(false);

  useEffect(() => {
    const hideAtendimento = hasAgendamentoEmAberto || isAgendamentoRealizado;

    setHidenAtendimentoButton(hideAtendimento);
  }, [hasAgendamentoEmAberto, isAgendamentoRealizado]);

  const changeAgendamento = useCallback(async () => {
    if (agendamento !== undefined) {
      await dispatch(attendanceRecordActions.changeAgendamento(agendamento));
    }
  }, [agendamento, dispatch]);

  const fetchIsAtendimentoRealizado = useCallback(async () => {
    const schedulingService: SchedulingService<any> = new SchedulingService();

    if (agendamento && agendamento.id) {
      try {
        const result = await schedulingService.getSimplifiedSchedulingById(
          agendamento.id
        );

        const isRealizado =
          result?.data?.data?.statusPresenca !== null &&
          result?.data?.data?.statusPresenca?.toUpperCase() ===
            AppointmentStatus.V.toUpperCase();

        setIsAgendamentoRealizado(isRealizado);
      } catch (error) {
        console.error("Erro ao verificar status do agendamento:", error);
      }
    }
  }, [agendamento]);

  const fetchProblems = useCallback(async () => {
    const patientId = pessoa?.idPessoa ?? pessoa?.id ?? agendamento?.idPessoa;
    if (!patientId) {
      setLoading(false);
      setProblems("");
      return;
    }

    try {
      setLoading(true);
      const response: any = await service.getProblems(patientId);
      const data: string = response?.data?.data;
      setProblems(data ?? "");
    } catch (error) {
      console.error("Erro ao buscar problemas:", error);
      setProblems("");
    } finally {
      setLoading(false);
    }
  }, [pessoa?.idPessoa, pessoa?.id, agendamento?.idPessoa]);

  useEffect(() => {
    fetchProblems();
    changeAgendamento();
    fetchIsAtendimentoRealizado();
    fetchAtendimentos();
  }, [fetchProblems, changeAgendamento, fetchIsAtendimentoRealizado, fetchAtendimentos]);

  return (
    <Styled.Container>
      <Styled.DivRowBetween isMobile={isMobile}>
        <H1>Lista de Problemas</H1>
        {
          !acessoProntuario ? 
            !hideAtendimentoButton && (
              <SolidButton
                width={isMobile ? 90 : 30}
                style={{ height: 25 }}
                color={Colors.SPM600}
                onClick={() =>
                  navigate(Paths.RegistroAtendimento, {
                    state: {
                      pessoa: pessoa,
                      agendamento: attendance.agendamento,
                    },
                  })
                }
              >
                Registrar Atendimento
              </SolidButton>
            )
          :
            ''
        }
      </Styled.DivRowBetween>
      <H3>Detalhes</H3>
      {!loading ? (
        <>
          {problems.length > 0 ? (
            <Styled.TextArea rows={10} disabled value={problems} />
          ) : (
            <p style={{ fontStyle: "italic" }}>
              O paciente não possui nenhum problema registrado.
            </p>
          )}
        </>
      ) : (
        <CircularProgress />
      )}
    </Styled.Container>
  );
};

export default ListProblem;
